// @flow
import React from "react";
import "./App.css";
import GridColumn from "../../components/GridColumn";
import Grid from "../../components/Grid";
import ProductDetails from "../ProductDetails";
import ProductPhotoSlider from "../../containers/ProductPhotoSlider";
import ProductInfo from "../../containers/ProductInfo";
import BuyBanner from "../../components/BuyBanner";
import { getViewportWidth } from "../../helpers/browser";
import ProductForm from "../ProductForm";
import { connect } from "react-redux";
import { type Option } from "fp-ts/lib/Option";
import { getDangerousHtml } from "../../helpers/components";
import AttributeHoverTooltip from "../AttributeHoverToolip";
import {
  holidayNoteSelector,
  setDefaultAttributeValues,
  livePreviewAttributesSelector,
  skuSelector
} from "../../store/modules/product";
import { getLivePreviewUrl } from "../../helpers/media";
import { attributesSelector } from "../../store/modules/attributes";
import Show from "../../functional/Show";
import CustomerReviews from "../../components/CustomerReviews";

const DEFAULT_VIEWPORT = 1000;
const getBrowserWidth = getViewportWidth(DEFAULT_VIEWPORT);

type State = {
  viewportWidth: number
};

type Props = {
  holidayNote: Option<string>,
  isConfigurable: boolean,
  attributes: Array<$AttributeUnionType>,
  sku: string,
  livePreviewAttributes: Array<string>,
  setDefaultValues: Function,
  productName: string,
  hasBuyBanner: boolean
};

class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.updateBrowserWidth = this.updateBrowserWidth.bind(this);
  }

  state = {
    viewportWidth: getBrowserWidth()
  };

  componentDidMount() {
    this.updateBrowserWidth();
    /**
     * 5/21 AB Test :: EN-127
     * Safe to delete after July 1, 2019
     */
    if (window.doMonetateAutoDefault === true) {
      this.props.setDefaultValues();
    } else {
      window.__monetateSetDefaultValues = this.props.setDefaultValues;
    }
    /**
     * End 5/21 AB Test :: EN-127
     */
    window.addEventListener("resize", this.updateBrowserWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateBrowserWidth);
  }

  updateBrowserWidth: Function;

  updateBrowserWidth() {
    this.setState({
      viewportWidth: getBrowserWidth()
    });
  }

  render() {
    const { viewportWidth } = this.state;
    const {
      holidayNote,
      livePreviewAttributes,
      attributes,
      sku,
      hasBuyBanner
    } = this.props;
    const livePreviewUrlOption = getLivePreviewUrl(sku, attributes, livePreviewAttributes);
    return (
      <div className="PdpApp monetate-test">
        <Grid>
          <GridColumn columnWidth="7" className="-pt-tiny" noPad>
            <ProductPhotoSlider key={livePreviewUrlOption.getOrElseValue("")} />
            {holidayNote
              .map(note => (
                <div className="holiday-note" dangerouslySetInnerHTML={getDangerousHtml(note)} />
              ))
              .getOrElseValue(null)}
            <div className="old-productInfo-shipping-accordion">
              {viewportWidth > 767 ? <ProductInfo /> : null}
            </div>
          </GridColumn>
          <GridColumn columnWidth="5" spacer="4">
            <ProductDetails />
            <ProductForm />
            {viewportWidth > 767 ? <AttributeHoverTooltip /> : null}
          </GridColumn>
        </Grid>
        <Grid>
          <Show when={hasBuyBanner === "1"}>
            <BuyBanner />
          </Show>
          <CustomerReviews />
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  holidayNote: holidayNoteSelector(state),
  isConfigurable: state.configuration,
  attributes: attributesSelector(state),
  sku: skuSelector(state),
  livePreviewAttributes: livePreviewAttributesSelector(state),
  productName: state.product.name,
  hasBuyBanner: state.rawProduct.buy_banner
});

const mapDispatchToProps = dispatch => ({
  setDefaultValues: () => dispatch(setDefaultAttributeValues())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.js